import React from 'react';
import MetronicCard from '@/app/components/layout/MetronicCard';

interface FileUploadProps {
  file: {
    name: string;
    status: 'uploading' | 'success' | 'error';
    progress: number;
    size: number;
    errorMessage?: string;
  };
  onCancel: () => void;
  onDelete: () => void;
}

const FileUpload: React.FC<FileUploadProps> = ({ file, onCancel, onDelete }) => {
  const formatFileSize = (bytes: number) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  const renderProgressBar = () => {
    switch (file.status) {
      case 'uploading':
        return (
          <div className="progress w-100">
            <div
              aria-valuemax={100}
              aria-valuemin={0}
              aria-valuenow={file.progress}
              className="progress-bar bg-primary"
              role="progressbar"
              style={{ width: `${file.progress}%` }}
            >
              {file.progress}%
            </div>
          </div>
        );
      case 'success':
        return <div className="text-success">Envio concluído</div>;
      case 'error':
        return (
          <div className="alert alert-danger" role="alert">
            {file.errorMessage ?? 'Envio falhou'}
          </div>
        );
    }
  };

  return (
    <MetronicCard className="mb-3">
      <div className="p-5">
        <div className="d-flex flex-column">
          <div className="d-flex justify-content-between align-items-start">
            <div className="mw-75 mw-sm-100">
              <p className="fw-bold mb-0 text-truncate" style={{ maxWidth: '350px' }}>
                {file.name}
              </p>
              {file.status === 'success' && <small className="text-muted">{formatFileSize(file.size)}</small>}
            </div>
            <div>
              {file.status === 'uploading' && (
                <svg
                  className="bi bi-x-circle cursor-pointer"
                  fill="currentColor"
                  height="16"
                  viewBox="0 0 16 16"
                  width="16"
                  xmlns="http://www.w3.org/2000/svg"
                  onClick={onCancel}
                >
                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                  <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                </svg>
              )}
              {(file.status === 'success' || file.status === 'error') && (
                <svg
                  className="bi bi-x-circle cursor-pointer"
                  fill="currentColor"
                  height="16"
                  viewBox="0 0 16 16"
                  width="16"
                  xmlns="http://www.w3.org/2000/svg"
                  onClick={onDelete}
                >
                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                  <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                </svg>
              )}
            </div>
          </div>
          <div className="mt-2">{renderProgressBar()}</div>
        </div>
      </div>
    </MetronicCard>
  );
};

export default FileUpload;
